import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { TextField, Select, MenuItem } from '@material-ui/core';
import months from '../../models/months';

const styles = {
  textField: {
    marginLeft: 10,
    marginRight: 10,
    width: '40px',
  },
};

class DayAndMonthPicker extends Component {
  handleChangeMonth = (month) => {
    const { onChange, value } = this.props;

    const date = moment().dayOfYear(value);
    date.month(month);

    onChange(date.dayOfYear());
  };

  handleChangeDay = (day) => {
    const { onChange, value } = this.props;

    const date = moment().dayOfYear(value);
    date.date(day);

    onChange(date.dayOfYear());
  };

  render() {
    const { value } = this.props;

    const date = moment().dayOfYear(value);

    const month = date.month();
    const day = date.date();

    return (
      <div>
        am
        <TextField
          style={styles.textField}
          value={day}
          type="number"
          onChange={e => this.handleChangeDay(e.target.value)}
        />
        <Select value={month} onChange={e => this.handleChangeMonth(e.target.value)}>
          {months.map(m => <MenuItem key={m.id} value={m.id}>{m.name}</MenuItem>)}
        </Select>
      </div>
    );
  }
}

DayAndMonthPicker.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default DayAndMonthPicker;
